import React, { useState } from "react";
import { Card } from "../../../components/ui/card";
import { X } from "lucide-react";
import { mockTestimonials } from "../../../mock";
import useInViewOnce from "../useInViewOnce";

const TestimonialsSection = () => {
  const [setRef, isInView] = useInViewOnce();
  const [activeImage, setActiveImage] = useState(null);

  return (
    <>
      <section id="testimoni" className="px-4 mb-12 md:mb-20 sm:px-6 md:px-0">
        <div
          ref={setRef}
          className={`${
            isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
          } transition-all duration-500 ease-out`}
        >
          {/* HEADER */}
          <header className="max-w-xl mb-6 md:mb-8">
            <h2 className="text-base font-semibold tracking-tight text-foreground sm:text-lg md:text-xl">
              Dipercaya Banyak Pelanggan
            </h2>
            <p className="mt-1 text-xs text-muted-foreground sm:text-sm">
              Foto pelanggan yang sudah memasak menu Aceh dengan bumbu
              CINEURASA.
            </p>
          </header>

          {/* GRID FOTO */}
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
            {mockTestimonials.map((item, index) => (
              <Card
                key={item.id}
                onClick={() => setActiveImage(item)}
                className="relative overflow-hidden transition-all duration-300 border shadow-sm cursor-pointer group rounded-3xl border-border bg-card/90 hover:-translate-y-1 hover:shadow-lg"
                style={{
                  transitionDelay: isInView ? `${index * 70}ms` : "0ms",
                }}
              >
                {/* FOTO 4:5 */}
                <div className="relative aspect-[4/5] w-full overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.06]"
                    loading="lazy"
                  />

                  {/* OVERLAY */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-90" />

                  {/* NAME */}
                  {/* <div className="absolute bottom-0 p-3">
                    <p className="text-sm font-semibold text-white">
                      {item.name}
                    </p>
                    <p className="text-[11px] text-white/80">
                      Pelanggan CINEURASA
                    </p>
                  </div> */}
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* LIGHTBOX */}
      {activeImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80"
          onClick={() => setActiveImage(null)}
        >
          <div
            className="relative max-h-[90vh] max-w-[90vw]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* CLOSE */}
            <button
              onClick={() => setActiveImage(null)}
              className="absolute flex items-center justify-center bg-white rounded-full shadow -top-4 -right-4 h-9 w-9 text-slate-900"
            >
              <X size={18} />
            </button>

            {/* IMAGE */}
            <img
              src={activeImage.imageUrl}
              alt={activeImage.name}
              className="max-h-[90vh] rounded-2xl object-contain"
            />

            {/* NAME */}
            <p className="mt-3 text-sm font-semibold text-center text-white">
              {activeImage.name}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TestimonialsSection;
